export const blockIconsHomeElectricBolt = (
	<span className='material-symbols-outlined'>electric_bolt</span>
);
